import React from 'react'
import { useNavigate } from 'react-router-dom'

// HOC helper to use navigation from react router v6 in old class components
export const withNavigate = (Component) => {
  const NavigateWrapper = (props) => {
    const navigate = useNavigate()
    return <Component navigate={navigate} {...props} />
  }

  return NavigateWrapper
}
